import React, { useContext } from 'react';
import './titles.css';
import { LanguageContext } from '../../../context/LanguageContext/LanguageContext';
import { titles, titlesEn } from '../../../json/nosotros/titles';
import { Parallax } from 'react-scroll-parallax';

const Titles = () => {
  const { language } = useContext(LanguageContext);
  const content = language === 'ES' ? titles : titlesEn;

  return (
    // <Parallax speed={-10}>
      <div className='container-titles'>
        <div className='container'>
          <div className='row'>
            <div className='col-12'>
              {content.map((item, index) => (
                <div key={index} className="title-block">
                  <h1>{item.title}</h1>
                  <h2>{item.subtitle}</h2>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    // </Parallax>
  );
};

export default Titles;
